const toggleDisplay = (element) => {
  const currentDisplay = element.style.getPropertyValue("display");

  if (currentDisplay === "none") {
    element.style.setProperty("display", "block", "important");
  } else {
    element.style.setProperty("display", "none", "important");
  }
};

const checkElement = () => {
  const countryRedirectMod = document.querySelector(
    "div#sg_country_redirect_mod"
  );

  if (countryRedirectMod) {
    const spicegemsBtnNo = countryRedirectMod.querySelector(
      "#spicegems_cr_btn_no"
    );

    if (spicegemsBtnNo) {
      spicegemsBtnNo.addEventListener("click", () =>
        toggleDisplay(countryRedirectMod)
      );
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    }
  }
};

const intervalId = setInterval(checkElement, 100);

const timeoutId = setTimeout(() => {
  clearInterval(intervalId);
}, 60000);

const assignClickEvent = (select) => {
  select.addEventListener("click", () => {
    const parent = select.closest(".promo-bar--country-selector");
    if (parent) {
      const selectOptions = parent.querySelector(".country-options");
      selectOptions?.classList.toggle("toggle-selector");
    }
  });
};

const checkAndAssignEvents = () => {
  const shipToSelects = document.querySelectorAll(".active-store-text");
  shipToSelects.forEach((select) => {
    if (!select.hasEventListener) {
      assignClickEvent(select);
      select.hasEventListener = true;
    }
  });
};

const intervalMobile = setInterval(() => {
  checkAndAssignEvents();
}, 1000);

setTimeout(() => {
  clearInterval(intervalMobile);
}, 60000);

document.addEventListener("DOMContentLoaded", () => {
  const findYotpoWidgetIsLoaded = () => {
    const yotpoWidgets = document.querySelectorAll(
      ".product-card-updated .yotpo-bottomline a.text-m"
    );

    if (yotpoWidgets.length == 0) return;

    clearInterval(intervalYotpo);

    yotpoWidgets.forEach((widget) => {
      let newLabel = widget.innerText.replace("Reviews", "");
      newLabel = newLabel.replace("Review", "");
      widget.innerText = newLabel;
    });
  };

  const intervalYotpo = setInterval(findYotpoWidgetIsLoaded, 100);

  setTimeout(() => {
    clearInterval(intervalYotpo);
  }, 6000);
});

class StickySidebarProduct {
  constructor() {
    this.mainSection = document.querySelector(".main-section-sticky-product");
    this.productSection = document.querySelector(".main-product");
    this.hiddenVariantInput = this.mainSection.querySelector("#variant_id-sticky");
    this.radioButtons = this.mainSection.querySelectorAll(".variant-option");
    this.buttonsSubmit = this.mainSection.querySelectorAll("button[type='submit']");

    this.init();
  }

  init() {
    window.addEventListener("scroll", () => this.handleScroll());

    this.radioButtons.forEach((radio) => {

      radio.addEventListener("change", (event) =>
        this.handleVariantChange(event)
      )
    }
    );

    this.checkCheckedRadio()
  }

  checkCheckedRadio() {
    const inputs = this.mainSection.querySelectorAll("input[type='radio']");
    inputs.forEach((input) => {
      input.closest("label").classList.toggle("checked", input.checked);
    });
  }


  handleScroll() {
    const sectionReference = document.querySelector('.quantity-submit__act-buttons').getBoundingClientRect();
    const mainSectionBottom = this.productSection.getBoundingClientRect().bottom;
    const scrollPosition = window.scrollY;

    console.log('sectionReference'  , sectionReference);
    const bottomPosition = (sectionReference.bottom + window.scrollY) + 20;
    const headerHeight = document.querySelector('.shopify-section.section-header').offsetHeight || 100;

    // if (scrollPosition < bottomPosition) {
    //   this.mainSection.classList.remove("fixed-actived", "fixed-disabled");
    // } else {
    //   this.mainSection.classList.add("fixed-actived");
    //   this.mainSection.classList.remove("fixed-disabled");
    // }

    this.mainSection.closest('.shopify-section').classList.toggle('sticky-nav', scrollPosition > bottomPosition);

    const stickyNav = document.querySelector('.section-sticky-desktop-product-main');
    stickyNav.style.top = `${headerHeight}px`;
  }

  handleVariantChange(event) {
    const selectedRadio = event.target;
    const variantId = selectedRadio.getAttribute("variant-id");
    const variantPrice = selectedRadio.getAttribute("variant-price");

    this.radioButtons.forEach((radio) =>
      radio.closest("label").classList.remove("checked")
    );

    selectedRadio.closest("label").classList.add("checked");

    if (this.hiddenVariantInput && variantId) {
      this.hiddenVariantInput.value = variantId;
    }

    if(variantPrice){
      const priceElements = this.mainSection.querySelectorAll(".price-product-sticky");
      priceElements.forEach((priceElement) => {
        priceElement.innerHTML = `$${variantPrice}`;
      });
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
   new StickySidebarProduct();
});